import { useEffect, useRef, useState, useCallback } from 'react';
import styled from 'styled-components';
import { AddressProps } from '@/custom-types';
import { useCreatePropertyContext } from '@/customHooks/useCreatePropertyContext';
import { AddressFormControlled } from './AddressFormControlled';

const FormWrapper = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.border.radius.md};
  padding: 2rem;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
`;

export const AddressForm = () => {
  const { setAddress: setAddressInContext, setButtonDisabled, setButtonEnabled, state: contextState } = useCreatePropertyContext();
  
  const [address, setAddress] = useState<AddressProps>(() => ({
    street: contextState.street || '',
    buildingNumber: contextState.buildingNumber || '',
    addressLine: contextState.addressLine || '',
    city: contextState.cityId || '',
    state: contextState.stateId || '',
    country: contextState.countryId || '',
    zipCode: contextState.zipCode || '',
  }));

  const addressRef = useRef(address);

  useEffect(() => {
    addressRef.current = address;
  }, [address]);

  const validateAddress = useCallback((addressData: AddressProps | null) => {
    return (
      addressData &&
      addressData.street &&
      addressData.buildingNumber &&
      addressData.city &&
      addressData.state &&
      addressData.country &&
      addressData.zipCode
    );
  }, []);

  const onChangeHandle = useCallback((addressData: AddressProps) => {
    setAddress(addressData);
  }, []);

  useEffect(() => {
    if (validateAddress(address)) {
      setButtonEnabled();
    } else {
      setButtonDisabled();
    }
  }, [address, validateAddress, setButtonEnabled, setButtonDisabled]);

  useEffect(() => {
    return () => {
      if (addressRef.current) {
        setAddressInContext(addressRef.current);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setAddressInContext]);

  return (
    <FormWrapper>
      <AddressFormControlled 
        onChange={onChangeHandle}
        defaultAddress={address}
      />
    </FormWrapper>
  );
};
